import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../client'
import { isLoggedIn } from '../client'
import type { MoveDetail, MoveLoadClass, MoveQuote, MoveSummary } from '../types'

export const MOVE_LOAD_CLASSES_KEY = ['move-load-classes'] as const
export const MY_MOVES_KEY = ['my-moves'] as const

export function useMoveLoadClasses() {
  return useQuery({
    queryKey: MOVE_LOAD_CLASSES_KEY,
    queryFn: () => apiFetch<MoveLoadClass[]>('api/v1/moves/load-classes'),
  })
}

export function useMoveQuote(
  params: {
    load_class: string
    weight_kg: number
    pickup_point_id: string
    dropoff_point_id: string
  } | null,
) {
  const ready =
    !!params &&
    !!params.load_class &&
    params.weight_kg > 0 &&
    !!params.pickup_point_id &&
    !!params.dropoff_point_id &&
    params.pickup_point_id !== params.dropoff_point_id

  return useQuery({
    queryKey: ['move-quote', params],
    queryFn: () =>
      apiFetch<MoveQuote>('api/v1/moves/quote', {
        params: {
          load_class: params!.load_class,
          weight_kg: params!.weight_kg,
          pickup_point_id: params!.pickup_point_id,
          dropoff_point_id: params!.dropoff_point_id,
        },
      }),
    enabled: ready && isLoggedIn(),
  })
}

export function useMyMoves() {
  return useQuery({
    queryKey: MY_MOVES_KEY,
    queryFn: () => apiFetch<MoveSummary[]>('api/v1/moves'),
    enabled: isLoggedIn(),
  })
}

export function useMove(requestId: string | undefined) {
  return useQuery({
    queryKey: ['move', requestId],
    queryFn: () => apiFetch<MoveDetail>(`api/v1/moves/${requestId}`),
    enabled: !!requestId && isLoggedIn(),
  })
}
